import { useState } from 'react'
import { Outlet } from '@tanstack/react-router'
import { fadeIn } from '@shared/design-system/styles/motion.css'
import { BottomNav } from './BottomNav'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { content, main, shell, shellBody } from './AppShell.css'

const SIDEBAR_COLLAPSED_STORAGE_KEY = 'vendepay-sidebar-collapsed'

function initialSidebarCollapsed() {
  if (typeof window === 'undefined') {
    return false
  }
  try {
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function AppShell() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(initialSidebarCollapsed)

  function handleSidebarCollapsedChange(next: boolean) {
    setSidebarCollapsed(next)
    try {
      window.localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(next))
    } catch {
      return
    }
  }

  return (
    <div className={shell} data-testid="app-shell">
      <Topbar />
      <div className={shellBody}>
        <Sidebar collapsed={sidebarCollapsed} onCollapsedChange={handleSidebarCollapsedChange} />
        <main className={main}>
          <div className={`${content} ${fadeIn}`}>
            <Outlet />
          </div>
          <BottomNav />
        </main>
      </div>
    </div>
  )
}
